/**
 * @description：指引类
 *
 */
import "./fafa_loading.css";

/**
 * 显示 loading (菊花，类似 ios 的加载中)
 * @param {string} text 
 */
function showCommonLoading(text) {
    var textHtml = text || "加载中";
    var bodyElement = document.querySelector('body');
    var loadingElement = document.querySelector('.loading-mask');
    if (loadingElement) {
        return;
    }

    loadingElement = document.createElement('div');
    var string =
        '<div class="loading-content">' +
        '<div class="m-load2">' +
        '<div class="line"><div></div><div></div><div></div><div></div><div></div><div></div><span class="circlebg"></span></div>' +
        '</div>' +
        '<div class="loading-text">' + textHtml + '...</div>' +
        '</div>';
    loadingElement.className = 'loading-mask';
    loadingElement.innerHTML = string;

    if (bodyElement) {
        bodyElement.appendChild(loadingElement);
    }
}

/**
 * 隐藏 loading (菊花)
 * @param {string} text 
 */
function hideCommonLoading() {
    var loadingElement = document.querySelector('.loading-mask');
    if (loadingElement) {
        loadingElement.parentNode.removeChild(loadingElement);
    }
}

/**
 * 提示语
 * @param {string} text 
 * @param {number} time 
 * @param {function} callback 当 time 传 -1 的时候，可以在这里面添加点击tips的回调方法，不传默认刷页面
 */
function showTips(text, time, callback) {
    var bodyElement = document.querySelector('body');
    var tipsElement = document.querySelector('.common-showtips');
    var click_event = function () {
        if (callback && typeof callback === 'function') {
            if (tipsElement) {
                tipsElement.removeEventListener("click", click_event);
                tipsElement.parentNode.removeChild(tipsElement);
            }
            callback();
        } else {
            window.location.reload(true);
        }
    };

    if (tipsElement) {
        tipsElement.removeEventListener("click", click_event);
        tipsElement.parentNode.removeChild(tipsElement);
        // return;
    }

    if (typeof text !== 'string' && typeof text !== 'number') {
        return;
    }

    tipsElement = document.createElement('div');
    tipsElement.className = 'common-showtips';
    tipsElement.innerHTML = text;

    if (bodyElement) {
        bodyElement.appendChild(tipsElement);

        if (time !== -1) {
            setTimeout(function () {
                tipsElement.className = "common-showtips common-hidetips"
                // tipsElement.parentNode.removeChild(tipsElement);
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }, time && typeof time === 'number' ? time : 3000);
        } else {
            tipsElement.addEventListener("click", click_event, false);
        }
    }
}

/**
 * 隐藏提示语
 */
function hideTips() {
    var tipsElement = document.querySelector('.common-showtips');

    if (tipsElement) {
        tipsElement.parentNode.removeChild(tipsElement);
    }
}

export { showCommonLoading, hideCommonLoading, showTips, hideTips };



// WEBPACK FOOTER //
// ./src/lib/prompt/main.js